export default "__VITE_ASSET__DGrraDy3__"